import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { IMsalContext, useMsal } from '@azure/msal-react';
import { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import LoadingScreen from '@lwtears/lwt-common-frontend/lib/LoadingScreen';
import LwtErrorBoundary from '@lwtears/lwt-common-frontend/lib/LwtErrorBoundary';
import { hasAuthCookies } from 'util/auth-cookie-util';
import { getApi } from 'api/';
import { getAccessToken } from 'config/auth';
import useUserStore from 'graph/state/query-hooks/use-user';
import AuthenticatedApp from './AuthenticatedApp';
import { NotepadSrc } from 'components/common/NotepadSrc';

const setAuthContext = async (azureContext: IMsalContext): Promise<void> => {
  const result = await getAccessToken(azureContext);
  result && getApi(AuthStrategy.HTTP_AUTHENTICATION).setAuthContext(result);
};

const GatedApp: React.FC = () => {
  const azureContext = useMsal();
  const [user] = useUserStore();
  const doesNotHaveAuthCookies = !hasAuthCookies();

  useEffect(() => {
    if (doesNotHaveAuthCookies) {
      const authorizeUser = async () => await setAuthContext(azureContext);
      authorizeUser();
    }
  }, [azureContext]);

  if (
    (doesNotHaveAuthCookies && azureContext.inProgress !== InteractionStatus.None) ||
    user.isAuthenticating ||
    !user.isAuthenticated
  ) {
    return <LoadingScreen backgroundImage={NotepadSrc} />;
  }

  return (
    <BrowserRouter>
      <LwtErrorBoundary>
        <AuthenticatedApp />
      </LwtErrorBoundary>
    </BrowserRouter>
  );
};

export default GatedApp;
